export default __webpack_public_path__ + "static/media/Tata Consultancy Services.ad610797.png";